export default {
  rpc: {},
  types: {
    Approvals: '[bool; 4]'
  }
};